import { z } from 'zod';

export const SessionIdParamSchema = z
  .string()
  .min(1, 'Session ID cannot be empty');

export type ISessionIdParamDto = z.infer<typeof SessionIdParamSchema>;
